/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc
 */
import * as References from './NotificationsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc#getNotifications
 */
export const GET_NOTIFICATIONS_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_NotificationsRpc_getNotifications';
export const GET_NOTIFICATIONS_QUERY: RegisteredQuery<
  'result',
  References.GetNotificationsRequestType,
  References.GetNotificationsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_NOTIFICATIONS_QUERY_FIELD_NAME,
  args: [
    'offset',
    'limit',
    'portalInstanceType',
    'notificationType',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.GetNotificationsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetNotificationsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getNotificationsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc#markNotificationAsRead
 */
export const MARK_NOTIFICATION_AS_READ_MUTATION_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_NotificationsRpc_markNotificationAsRead';
export const MARK_NOTIFICATION_AS_READ_MUTATION: RegisteredQuery<
  'result',
  References.MarkNotificationAsReadRequestType,
  References.MarkNotificationAsReadResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: MARK_NOTIFICATION_AS_READ_MUTATION_FIELD_NAME,
  args: [
    'notificationId',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.MarkNotificationAsReadRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.MarkNotificationAsReadResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.markNotificationAsReadRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc#markAllNotificationsAsRead
 */
export const MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_NotificationsRpc_markAllNotificationsAsRead';
export const MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION: RegisteredQuery<
  'result',
  References.MarkAllNotificationsAsReadRequestType,
  References.MarkAllNotificationsAsReadResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION_FIELD_NAME,
  args: [
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.MarkAllNotificationsAsReadRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.MarkAllNotificationsAsReadResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.markAllNotificationsAsReadRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc#deleteNotification
 */
export const DELETE_NOTIFICATION_MUTATION_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_NotificationsRpc_deleteNotification';
export const DELETE_NOTIFICATION_MUTATION: RegisteredQuery<
  'result',
  References.DeleteNotificationRequestType,
  References.DeleteNotificationResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_NOTIFICATION_MUTATION_FIELD_NAME,
  args: [
    'notificationId',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
    'companyId',
    'tolerateInstanceAccessDenied',
  ],
  fetcher(
    request: References.DeleteNotificationRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteNotificationResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.deleteNotificationRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
